import React from "react";
import { useSelector} from 'react-redux';
import MapWrapper from '../MapWrapper/MapWrapper'
import { tasksToMarker } from '../../helpers/taskToMarker.helper';

const Map = (prop) => {
  const { task } = useSelector(state => state.tasks);
  const markers = tasksToMarker(task, task.id);
  const [marker] = markers;
  let location = false;
  if(marker?.coordinate?.lat && marker?.coordinate?.lon) {
    location = [marker.coordinate.lat, marker.coordinate.lon];
  }

  return <div className="u-margin-top u-margin-bottom mapholder">
    <MapWrapper markers={[]} location={location}/>
  </div>;
}
export default Map;
